import React from "react";
import { TooltipProps } from "./definitions";
import { Tooltip as TooltipMantine } from "@mantine/core";

export const Tooltip = ({
  children,
  label,
  position = "top",
  placement = "center",
  withArrow = true,
  disabled,
  className,
}: TooltipProps) => {
  return (
    <TooltipMantine
      classNames={{
        // root: children && children[0].className,
        // "p-3 bg-yellow-500 text-white rounded-md"
        body: `bg-primary rounded-md px-5 py-3 ${className}`,
        arrow: `bg-primary rounded-none ${className}`,
      }}
      label={label}
      position={position}
      placement={placement}
      withArrow={withArrow}
      arrowSize={8}
      disabled={disabled}
      // closeDelay={800}
    >
      {children}
    </TooltipMantine>
  );
};
